import React from 'react';
import { Field as BaseField } from 'react-final-form';

interface Props {
    children: React.ReactNode;
    for: string;
    when: boolean | ((value) => boolean);
}

export default function Condition({ children, for: name, when }: Props) {
    return (
        <BaseField name={name} subscription={{ value: true }}>
            {({ input: { value } }) => {
                const condition = typeof when === 'function' ? when(value) : when === value;
                return condition ? children : null;
            }}
        </BaseField>
    );
}
